import { checkCoupon } from "./check-coupon";

export function validateEmail(email: string): boolean {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailPattern.test(email);
}

export function validatePhoneNumber(phoneNumber: string): boolean {
  // Regular expression for flexible phone number validation
  const phonePattern =
    /^(\+?\d{1,3}[-.\s]?)?(\(?\d{1,4}\)?[-.\s]?)?[\d\s.-]{5,15}$/;
  return phonePattern.test(phoneNumber);
}

export const validateForm = async (
  state: any,
  setState: any,
  fields: any,
  product?: string
): Promise<boolean> => {
  const newFields = { ...state };

  for (let field of fields) {
    switch (field) {
      case "promoCode": {
        const couponRate =
          state.promoCode.value &&
          (await checkCoupon(state.promoCode.value, product));
        if (state.promoCode.value && !couponRate) {
          newFields.promoCode.error = {
            fr: "Coupon expiré ou non valide",
            ar: "قسيمة منتهية الصلاحية أو غير صالحة",
            en: "Expired or invalid coupon",
          };
          newFields.promoCode.value = "";
        } else {
          newFields.promoCode.error = {
            fr: "",
            ar: "",
            en: "",
          };
        }
        break;
      }
      case "email": {
        if (!validateEmail(state.email.value)) {
          newFields.email.error = {
            fr: "Veuillez saisir un email valide",
            ar: "يرجى إدخال بريد إلكتروني صالح",
            en: "Please enter a valid email",
          };
        }
        break;
      }
      case "phone": {
        if (!validatePhoneNumber(state.phone.value)) {
          if (!state.phone.value) {
            newFields.phone.error = {
              fr: "Ce champ est obligatoire",
              ar: "هذا الحقل مطلوب",
              en: "This field is required",
            };
          } else {
            newFields.phone.error = {
              fr: "Le téléphone n’est pas valide",
              ar: "الهاتف غير صالح",
              en: "Invalid phone number",
            };
          }
        }
        break;
      }
      default: {
        if (!state[field]?.value) {
          newFields[field] &&
            (newFields[field].error = {
              fr: "Ce champ est obligatoire",
              ar: "هذا الحقل مطلوب",
              en: "This field is required",
            });
        }
        break;
      }
    }
  }

  const isValidationError = Object.keys(newFields).reduce(
    (acc: boolean, key: string) => {
      return !!newFields[key]?.error?.en || acc;
    },
    false
  );
  if (isValidationError) {
    setState(newFields);
  }
  return isValidationError;
};
